import ModalHeader from '@/components/modal/ModalHeader.tsx';
import React from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import useCreateCustomField from '@/features/dashboard/tourCustomFields/hooks/useCreateCustomField.ts';
import { tourCustomFieldsRoute } from '@/features/dashboard/tourCustomFields/routes/tourCustomFieldsRoute.ts';
import DropdownCustomFieldForm from '@/features/dashboard/tourCustomFields/components/DropdownCustomFieldForm.tsx';
import {
  DropdownCustomFieldFormData,
  DropdownCustomFieldInputData,
  dropdownCustomFieldSchema,
} from '@/features/dashboard/tourCustomFields/schemas/dropdownCustomFieldSchema.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';

const DropdownCustomFieldAddModal = ({ onClose }: { onClose: () => void }) => {
  const { tourId } = tourCustomFieldsRoute.useParams();
  const form = useForm<DropdownCustomFieldInputData>({
    resolver: debugZodResolver(dropdownCustomFieldSchema),
    defaultValues: {
      type: FieldType.DROPDOWN,
      options: [{ label: '' }, { label: '' }],
    },
  });

  const createCustomField = useCreateCustomField(tourId);

  const handleSubmit = (data: DropdownCustomFieldFormData) => {
    createCustomField.mutate(data, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader
        title="Skonfiguruj pole wybór jednokrotny"
        onClose={onClose}
      />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <DropdownCustomFieldForm />
          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Zamknij
            </ActionButton>
            <ActionButton tone="accent" size="sm" type="submit">
              Dodaj
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default DropdownCustomFieldAddModal;
